import BPApi from '@/api/Businessprocess';
import BusinessProcess from './BusinessProcess';


export default class BusinessProcessCollection {
  /**
   * Inmutable BusinessProcess collection manager.
   **/

  constructor(data) {
    if (data === undefined || data === null)
      throw "No data given to QUnitCollection";

    this._bps = {};
    for (const bp of data) {
      this._bps[bp.reference] = new BusinessProcess(bp);
      Object.defineProperty(this, bp.reference, {
        get() {
          return this.get_value(bp.reference);
        },
      });
    }
  }

  get_value(key) {
    return this._bps[key];
  }

  static async fetch(centro_id) {
    let data = undefined;
    try {
      data = await BPApi.bpmap(centro_id);
    } catch (err) {
      console.warn(`Network error. BPApi listing failed →`, err);
      throw err;
    }
    return new BusinessProcessCollection(data);
  }
}
